import { ReactElement } from 'react';

export enum IntegrationContext {
    HubSpot = 'hubspot',
}

export enum IntegrationReturnToLabel {
    HubSpot = 'HubSpot',
    Default = 'previous page',
}

export enum WorkflowStatusType {
    UpgradeRequired = 'upgradeRequired',
    NotFound404 = 'notFound404',
    SignatureRequestSent = 'signatureRequestSent',
    TemplateCreated = 'templateCreated',
    ErrorCannotCreateEditTemplate = 'cannot_create_edit_template',
    ErrorFromTokenRequest = 'error_from_token_request',
    ErrorParamFound = 'error_param_found',
    ErrorIntegrationInvalid = 'integration_invalid',
    ErrorInvalidCsrf = 'invalid_csrf',
    ErrorInvalidEventHash = 'invalid_event_hash',
    ErrorInvalidRequestMethod = 'invalid_request_method',
    ErrorMissingParameter = 'missing_parameter',
    ErrorNoAccountApiApp = 'no_account_api_app',
    ErrorNoCacheFromState = 'no_cache_from_state',
    ErrorNoCodeFromCallback = 'no_code_from_callback',
    ErrorNoHSAccount = 'no_hellosign_account',
    ErrorNoIntegrationInstantiated = 'no_integration_instantiated',
    ErrorNoStateValue = 'no_state_value',
    ErrorNonPaidPlan = 'non_paid_plan',
    ErrorTeamFeatureRequired = 'team_feature_required',
    ErrorTeamInviteRequired = 'team_invite_required',
    ErrorUnknown = 'unknown_error',
    ErrorUserEmailMismatch = 'user_email_mismatch',
}

export type WorkflowStatusProps = {
    statusType: WorkflowStatusType,
    actionUrl?: string,
    actionEventOverride?: () => void,
    context?: string,
}

export type WorkflowStatusData = {
    title: string,
    description?: string | ReactElement,
    image?: ReactElement,
    actionButtonLabel?: string,
    displayHSLogo?: boolean,
    actionEvent?: () => void,
}

export enum PrepAndSendOriginatedAction {
    CreateOneTimeDoc = 'createOneTimeDoc',
    CreateTemplate = 'createTemplate',
    SendTemplate = 'sendTemplate',
}

export type PrepAndSendLoadProps = {
    response: PrepAndSendSuccess,
    originatedAction: PrepAndSendOriginatedAction,
    context: string,
}

export type PrepAndSendSuccess = {
    success: true,
    claimUrl: string,
    clientId: string,
    signatureRequestId?: string,
  };

export type HsErrorResponse = {
    error: string,
    statusCode: number,
    success: boolean,
  };

export type IntegrationSpaProps = {
    associatedObjectId: number,
    associatedObjectType: string,
    identifier: string,
    context: string,
};

export type IntegrationNamespaceState = {
    selectedTemplateId: string | null,
    workflowError: WorkflowStatusType | null,
}

export interface SetWorkflowError {
    type: Actions.SetWorkflowError,
    payload: WorkflowStatusType | null,
}

export interface SetSelectedTemplateId {
    type: Actions.SetSelectedTemplateId,
    payload: string,
}

export enum Actions {
    SetWorkflowError = 'integration/SetWorkflowError',
    SetSelectedTemplateId = 'integration/SetSelectedTemplateId',
}

export type IntegrationAction = SetSelectedTemplateId | SetWorkflowError;

export type Template = {
    templateId: string,
    title: string,
    isLocked: boolean,
    canEdit: boolean,
};

export type ListInfo = {
    numPages: number,
    numResults: number,
    page: number,
    pageSize: number,
};

export type TemplateList = {
    templates: Template[],
    listInfo: ListInfo,
};
